import {IFieldDescriptor, IMixerChannelData} from '@/features/mixer'
import {InitViewTemplate} from '../..'
import {useContext} from 'react'
import {
  DataSourceTemplates,
  DataSourcesContext,
  IDataSourceItem,
  DataSourceItemSelect,
  similarTitlesSource,
} from '@/features/data-sources'

export const InitViewSimilarity: InitViewTemplate = (props: {
  descriptor: IFieldDescriptor
  finalize: (
    descriptor: IFieldDescriptor,
    initParams: Parameters<typeof similarTitlesSource>[0]
  ) => void
  data?: IMixerChannelData
}) => {
  const {descriptor, finalize, data} = props

  const {activeCatalogName, addSource} = useContext(DataSourcesContext)

  function handleOnItemSelect({_id, title}: IDataSourceItem) {
    const params = {
      catalog: activeCatalogName,
      id: _id,
    }
    addSource(DataSourceTemplates.similar(params))
    finalize(
      {
        ...descriptor,
        label: `ainar - similarity: "${title}"`,
        sourcePath: `_merged.similar["${_id}"]`,
      },
      params
    )
  }

  return (
    <DataSourceItemSelect
      value={data?.initParams}
      onSelect={handleOnItemSelect}
    />
  )
}
